import {ref} from 'vue';

const appContext = ref(null);

export default (context) => {
    appContext.value = context;
};

export const getAppContext = () => appContext.value;
